export default {
  // Used to store a default entity in local storage
  DefaultEntityKey: 'SSO_DEFAULT_ENTITY_ID',
};
